/**
 * Semantic VoiceBot performance-envelope capture and simulation profiles.
 * React UI must not mention vb* flags. Profiles are uncalibrated until
 * real-device reports exist — names are simulation labels only.
 */

export const ENVELOPE_SIM_PROFILES = Object.freeze({
  OFF: 'off',
  NORMAL: 'normal',
  LAPTOP: 'laptop',
  RUST_BUCKET: 'rust-bucket',
});

const PROFILE_SET = new Set(Object.values(ENVELOPE_SIM_PROFILES));

/** Uncalibrated starting points — not claimed to match any real machine. */
const PROFILE_PRESSURE = Object.freeze({
  [ENVELOPE_SIM_PROFILES.OFF]: { busyMs: 0, intervalMs: 16 },
  [ENVELOPE_SIM_PROFILES.NORMAL]: { busyMs: 0, intervalMs: 16 },
  [ENVELOPE_SIM_PROFILES.LAPTOP]: { busyMs: 8, intervalMs: 16 },
  [ENVELOPE_SIM_PROFILES.RUST_BUCKET]: { busyMs: 12, intervalMs: 16 },
});

export function normalizeSimProfile(value) {
  const next = String(value || '').trim().toLowerCase();
  if (next === 'rust' || next === 'rustbucket' || next === 'rust-bucket-like') {
    return ENVELOPE_SIM_PROFILES.RUST_BUCKET;
  }
  if (next === 'laptop-like' || next === 'laptop') {
    return ENVELOPE_SIM_PROFILES.LAPTOP;
  }
  if (PROFILE_SET.has(next)) return next;
  return ENVELOPE_SIM_PROFILES.OFF;
}

export function pressureForProfile(profile) {
  const key = normalizeSimProfile(profile);
  return PROFILE_PRESSURE[key] || PROFILE_PRESSURE[ENVELOPE_SIM_PROFILES.OFF];
}

export function isSimPressureAllowed() {
  if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production') {
    return false;
  }
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

export function readEnvelopeUrlFlags() {
  if (typeof window === 'undefined') {
    return { envelopeEnabled: false, simProfile: ENVELOPE_SIM_PROFILES.OFF };
  }
  try {
    const params = new URLSearchParams(window.location.search);
    const envelopeEnabled = params.get('voicebotEnvelope') === '1';
    const simProfile = normalizeSimProfile(params.get('voicebotSim'));
    return { envelopeEnabled, simProfile };
  } catch {
    return { envelopeEnabled: false, simProfile: ENVELOPE_SIM_PROFILES.OFF };
  }
}
